import React from 'react'
import { useSelector } from 'react-redux'
import cn, { Argument as ClassName } from 'classnames'

import { useEntitlements } from '../../../common/hooks/useEntitlements'
import useText from '../../../common/hooks/useText'
import { selectIsConfirmedScopedAccessActive } from '../../redux/features/scopedAccessSession/scopedAccessSessionSlice'
import { canAccessBillingPage } from '../../../lib/entitlementUtils'
import { PageHeader } from '../../../lib/page-header'

export type AdminPageHeaderProps = {
    className?: ClassName
    style?: React.CSSProperties
}

export function AdminPageHeader({ className, style }: AdminPageHeaderProps): React.ReactElement {
    const text = useText()
    const entitlements = useEntitlements()
    const isConfirmedScopedAccessActive = useSelector(selectIsConfirmedScopedAccessActive)
    const canAccessBilling = canAccessBillingPage(entitlements)
    const MENU_LINKS = [
        { href: '/dashboard', labelCode: 'btnDashboard' },
        { href: '/chargepoints', labelCode: 'lblChargers' },
        { href: '/pools', labelCode: 'btnPools' },
        { href: '/users', labelCode: 'lblUsers' },
        { href: '/nfcTags', labelCode: 'lblRFID' },
        {
            href: '/loadbalancer',
            labelCode: 'btnLoadbalancer',
        },
        { href: '/measurementDevices', labelCode: 'lblMeasurementDevices' },
        { href: '/reports', labelCode: 'btnReports' },
        { href: '/settings', labelCode: 'lblSettings' },
        ...(canAccessBilling ? [{ href: '/billing', labelCode: 'lblBilling' }] : []),
    ]
    return (
        <PageHeader
            className={cn(className)}
            style={style}
            links={MENU_LINKS}
            title="Admin"
            disableLogout={isConfirmedScopedAccessActive}
            logoutDisabledReason={isConfirmedScopedAccessActive ? text('msgScopedAccessLogoutDisabled') : undefined}
        />
    )
}
